'use client';
import { SafeSessionStorage } from '#pplx/frontend/browser-storage/sessionStorage.js';
import { useWebPlatform } from '#pplx/frontend/platform-components/useWebPlatform.js';
import { useCallback, useState } from 'react';
// sessionStorage rather than a cookie on purpose: the modal must come back on
// the next app launch, but not on every return to the home route within one.
const CLOSED_SESSION_KEY = 'pplx.windowsLegacyAppUpsellModal.closed';
export const useWindowsLegacyAppUpsellModalPlan = (enabled) => {
    const { device: { isWindowsApp }, } = useWebPlatform();
    const [closed, setClosed] = useState(() => SafeSessionStorage.getItem(CLOSED_SESSION_KEY) === '1');
    const close = useCallback(() => {
        SafeSessionStorage.setItem(CLOSED_SESSION_KEY, '1');
        setClosed(true);
    }, []);
    return {
        close,
        show: enabled && isWindowsApp && !closed,
    };
};
//# sourceMappingURL=useWindowsLegacyAppUpsellModalPlan.js.map